export default __webpack_public_path__ + "static/media/logo.3b5c050f.svg";